export default "__VITE_ASSET__CA2Re3cv__"